import { getApplicationCount } from "services/dashboardService";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "utilities/api";

export async function getAllApps(accessToken: string) {
  var appsUrl = window.env.baseURL + "application/";
  return getApplicationCount(accessToken).then((countResponse: any) => {
    var url =
      appsUrl +
      "?currentPageNumber=1&itemPerPage=" +
      countResponse[0].data.count;

    return getWithAuth(url, accessToken).then((response) => {
      return response;
    });
  });
}

export async function getAppplications(
  accessToken: string,
  searchString: string,
  currentPageNumber: number = 1,
  itemPerPage: number = 15
) {
  var url =
    window.env.baseURL +
    `application?searchString=${searchString}&currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}`;

  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function getVersionList(accessToken: string, query: string) {
  var url = window.env.baseURL + "application/version/" + query;
  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function addNewApplication(accessToken: string, params: any) {
  var url = window.env.baseURL + "application";

  return postWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function updateApplication(
  accessToken: string,
  id: number,
  params: any
) {
  var url = window.env.baseURL + "application/" + id;

  return putWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function getApplicationById(accessToken: string, id: string) {
  var url = window.env.baseURL + `application/${id}`;

  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function grantAccessToApp(
  accessToken: string,
  appid: number,
  userid: number[]
) {
  var url = window.env.baseURL + `application/${appid}/grantAccess`;
  return postWithAuth(url, accessToken, { userIdList: userid }).then(
    (response) => {
      return response;
    }
  );
}

export async function removeAccessFromApp(
  accessToken: string,
  appid: number,
  userid: number[]
) {
  var url = window.env.baseURL + `application/${appid}/removeAccess`;
  return putWithAuth(url, accessToken, { userIdList: userid }).then(
    (response) => {
      return response;
    }
  );
}

export async function grantNotificationToApp(
  accessToken: string,
  appid: number,
  userid: number[]
) {
  var url = window.env.baseURL + `application/${appid}/grantNotification`;
  return postWithAuth(url, accessToken, { userIdList: userid }).then(
    (response) => {
      return response;
    }
  );
}

export async function removeNotificationFromApp(
  accessToken: string,
  appid: number,
  userid: number[]
) {
  var url = window.env.baseURL + `application/${appid}/removeNotification`;
  return putWithAuth(url, accessToken, { userIdList: userid }).then(
    (response) => {
      return response;
    }
  );
}

export async function updateApplicationWarningThreshold(accessToken: string, params: any) {
  var url = window.env.baseURL + "application/updateWarningThreshold";

  return postWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function getTrackedWarningThreshold(
  accessToken: string,
  applicationId: number
) {
  var url =
    window.env.baseURL +
    "application" +
    "/applicationWarningThreshold/" +
    applicationId;
  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function trackWarningThreshold(accessToken: string, params: any) {
  var url = window.env.baseURL + "application/trackWarningThreshold";

  return postWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function untrackWarningThreshold(
  accessToken: string, 
  applicationId: number) {
  var url = window.env.baseURL + "application/trackWarningThreshold/" + applicationId;

  return deleteWithAuth(url, accessToken).then((response) => {
    return response;
  });
}
